import { Effect } from "../Materials/effect";
import "./ShadersInclude/helperFunctions";
var name = 'extractHighlightsPixelShader';
var shader = "#include<helperFunctions>\n\nvarying vec2 vUV;\nuniform sampler2D textureSampler;\nuniform float threshold;\nuniform float exposure;\nvoid main(void)\n{\ngl_FragColor=texture2D(textureSampler,vUV);\nfloat luma=getLuminance(gl_FragColor.rgb*exposure);\ngl_FragColor.rgb=step(threshold,luma)*gl_FragColor.rgb;\n}";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var extractHighlightsPixelShader = { name: name, shader: shader };
//# sourceMappingURL=extractHighlights.fragment.js.map